// extracted by mini-css-extract-plugin
export default {"root":"_2_wKi","variant-horizontal":"_3YhI2","variantHorizontal":"_3YhI2","title":"_5w7A0","message":"_3uhoj","core-star":"_3SDfr","coreStar":"_3SDfr"};